import { render, staticRenderFns } from "./pix-generator.vue?vue&type=template&id=cd35fa10&scoped=true&"
import script from "./pix-generator.vue?vue&type=script&lang=js&"
export * from "./pix-generator.vue?vue&type=script&lang=js&"
import style0 from "./pix-generator.vue?vue&type=style&index=0&id=cd35fa10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd35fa10",
  null
  
)

export default component.exports